import request from '@/utils/http';
// 投标费用列表
export const bidSupplierCostList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplierCostList`,
        method: 'post',
        data: params
    });
};
// 投标保证金退款
export const saveRefundDeposit = (params, id) => {
    return request({
        url: `/api-srm-web/bid/bidSupplierCosts/saveRefundDeposit`,
        method: 'post',
        data: params
    });
};

// 取消接口
export const bidSupplier = (id) => {
    return request({
        url: `/api-srm-web/bid/bidSupplierExt/${id}`,
        method: 'put',
        data: { 'deleteFlag': '1' }
    });
};

export const contractDeposit = (params) => {
    return request({
        url: `/api-srm-web/bid/bidBond/contractDeposit`,
        method: 'post',
        data: params
    });
};
